module.exports = __webpack_public_path__ + "img/cog.4a4b8000.svg";